import { Controller } from '@hotwired/stimulus'
import { useResize, useDebounce } from 'stimulus-use'
import flatpickr from 'flatpickr'
import Cookies from 'js-cookie'

const calendarFiltersExpandedCookieName = 'calendar_filters_expanded'
const calendarUaShiftsExpandedCookieName = 'calendar_ua_shifts_expanded'

export default class extends Controller {
  static debounces = ['resize']
  static targets = ['frame', 'body', 'container', 'row', 'filtersForm', 'filtersAppliedInfo', 'dateSelect']
  static values = { initialLoad: { type: Boolean, default: true },
                    initialUrl: String,
                    containerWidth: Number,
                    view: { type: String, default: 'flexible' },
                    startsOn: String,
                    subjectRosterIds: { type: Array, default: [] },
                    //subjectUserIds: { type: Array, default: [] },
                    filters: { type: Object, default: {} },
                    filtersExpanded: Boolean,
                    uaShiftsExpanded: Boolean }

  connect() {
    //console.log('calendar controller connect: size filters val?', Object.keys(this.filtersValue).length)
    useDebounce(this, { wait: 1500 }) // wait 1.5s after finishing resize before pulling new view, default is 200ms
    useResize(this)
  }

  resize({ width }) {
    if(width && width != 0 && width == this.containerWidthValue) {
      // same width, so skip
      return
    }

    if(this.viewValue != 'flexible' && this.viewValue != 'compact') {
      //console.log('resize | skip cuz not flexible or compact')
      return
    }

    //console.log(`resize | initial: ${this.initialLoadValue} | width: ${width} | this.viewValue = ${this.viewValue}`)

    this.containerWidthValue = width

    let url = null
    if(this.initialLoadValue) {
      url = new URL(this.initialUrlValue)
    } else {
      url = new URL(`${this.initialUrlValue.split('?')[0]}?${window.location.href.split("?")[1]}`)
    }

    if(this.initialLoadValue) {
      this.initialLoadValue = false
    }

    url.searchParams.set('calendar_container_width', this.containerWidthValue)
    const src = url.toString()

    //this.renderTurboStreamFromUrl(src, 'update', 'calendar')

    Turbo.visit(src, { frame: 'calendar' })
  }

  filtersFormSubmit(event) {
    const form = event.target
    const formData = new FormData(form)

    let newFiltersVal = {}

    // for (const [name, value] of formData.entries()) {
    for (const key of formData.keys()) {
      const is_array = key.includes('[]')

      let val = is_array ? formData.getAll(key) : formData.get(key)

      if(!val || val == '' || val == [''] || val == 'Filter') {
        continue
      }

      if(is_array) {
        val = val.filter((v) => v != '')
      }
      newFiltersVal[key] = val
    }

    this.filtersValue = newFiltersVal
  }

  afterInitialLoad() {
    this.setInitialValues()
    //console.log('afterInitialLoad ') //, this.subjectRosterIdsValue)

    this.frameTarget.addEventListener('turbo:frame-load', async (_event) => {
      //console.log('turbo:frame-load target.id |', event.target.getAttribute('id'))

      if(!this.initialLoadValue) {
        this.changeBrowserUrl()
      }
    })

    // was async
    addEventListener('turbo:before-fetch-request', async (event) => {
      event.preventDefault()

      const target_id = event.target.getAttribute('id')

      // console.log(`turbo:before-fetch-request | event`, event)
      // console.log(`turbo:before-fetch-request | target_id: ${target_id}`)
      // console.log(`turbo:before-fetch-request | event.detail.url ${event.detail.url}`)
      //console.log(`turbo:before-fetch-request | filters`, this.filtersValue)
      //console.log('turbo:before-fetch-request | event.target', event.target)

      // add calendar specific params to the url
      event.detail.url.searchParams.set('calendar_container_width', this.containerWidthValue)

      event.detail.url.searchParams.set('view', this.viewValue)

      if(this.startsOnValue) {
        event.detail.url.searchParams.set('starts_on', this.startsOnValue)
      }

      // add filters to the url like new shift
      if(this.filtersValue && this.filtersValue != {} && (!target_id || target_id == 'modal' || target_id.startsWith('calendar'))) {
        // console.log('turbo:before-fetch-request | this.filtersValue', this.filtersValue)
        for (const key in this.filtersValue) {
          const is_array = key.includes('[]')
          const val = this.filtersValue[key]

          //if(val && val != '' && val != [] && val != [""]) {
            if(is_array) {
              event.detail.url.searchParams.delete(key) // clear first

              for (const v of val) {
                event.detail.url.searchParams.append(key, v)
              }
            } else if(val && val != '') {
              event.detail.url.searchParams.set(key, val)
            } else {
              event.detail.url.searchParams.delete(key)
            }
          // } else {
          //   console.log('turbo:before-fetch-request | search params delete key', key)
          //   event.detail.url.searchParams.delete(key)
          // }
        }
      }

      if(this.subjectRosterIdsValue && this.subjectRosterIdsValue.length > 0) {
        event.detail.url.searchParams.delete('subject_roster_ids[]')
        for (const v of this.subjectRosterIdsValue) {
          event.detail.url.searchParams.append('subject_roster_ids[]', v)
        }
      }

      // if(this.subjectUserIdsValue && this.subjectUserIdsValue.length > 0) {
      //   event.detail.url.searchParams.delete('subject_user_ids[]')
      //   for (const v of this.subjectUserIdsValue) {
      //     event.detail.url.searchParams.append('subject_user_ids[]', v)
      //   }
      // }

      event.detail.resume()
    })

    addEventListener('turbo:before-stream-render', (event) => {
      const target = event.target.getAttribute('target')

      // console.log('turbo:before-stream-render | target ', target)

      //this.loadingValue = false

      // const fallbackToDefaultActions = event.detail.render
      // const that = this

      // event.detail.render = function (streamElement) {
      //   console.log('streamElement target', streamElement.getAttribute('target'))
      //   if(streamElement.getAttribute('target').startsWith('calendar-')) {
      //     that.renderPopovers()
      //   }
      //   fallbackToDefaultActions(streamElement)
      // }

      if(target == 'calendar-body') {
        this.changeBrowserUrl()
      }
    })

    // addEventListener("turbo:before-visit", async (event) => {
    //   console.log("turbo:before-visit")
    // })

    // addEventListener("turbo:before-frame-load", async (event) => {
    //   console.log("turbo:before-frame-load", this.calendarContainerWidthValue)
    // })

    // this.frameTarget.addEventListener('turbo:frame-render', async (event) => {
    //   console.log("turbo:frame-render", this.calendarContainerWidthValue)
    // })

    // addEventListener("turbo:before-frame-render", async (event) => {
    //   console.log("turbo:before-frame-render", this.calendarContainerWidthValue)
    // })

    // addEventListener('turbo:before-fetch-response', (event) => {
    //   console.log('turbo:before-fetch-response', event)
    // })

    // addEventListener('turbo:before-render', (event) => {
    //   console.log('turbo:before-render')
    // })

    // addEventListener('turbo:fetch-request-error', ({ _target }) => {
    //   // console.log('turbo:fetch-request-error')
    // })
  }

  // set initial values starts_on, view, filters, from url query params
  setInitialValues() {
    // pass from filter object from rails side
    const filterKeys = ['grades[]', 'duty_ids[]', 'roster_ids[]', 'team_ids[]', 'tag_ids[]', 'location_ids[]',
      'q_user_name', 'oncall', 'pos', 'ltft', 'ar', 'subject_roster_ids[]'] //, 'subject_user_ids[]']

    const url = new URL(this.initialUrlValue)
    //console.log('setInitialValues | this.initialUrlValue ', this.initialUrlValue, url.searchParams.entries())

    let initFiltersVal = {}

    for (const [key, value] of url.searchParams.entries()) {
      // if(!value || value == '' || value == ['']) {
      //   continue
      // }

      if(key == 'starts_on') {
        this.startsOnValue = value
      } else if (key == 'view') {
        this.viewValue = value
      } else if(filterKeys.includes(key)) {
        const is_array = key.includes('[]')

        if(is_array) {
          initFiltersVal[key] ||= []
          initFiltersVal[key].push(value)
        } else {
          initFiltersVal[key] = value
        }
      }

      this.filtersValue = initFiltersVal
    }
    this.filtersExpandedValue = Cookies.get(calendarFiltersExpandedCookieName)
  }

  changeBrowserUrl() {
    let url = new URL(window.location.href.split('?')[0])
    //console.log('changeBrowserUrl before url', url.toString())
    if(this.startsOnValue) {
      url.searchParams.set('starts_on', this.startsOnValue)
    } else {
      url.searchParams.delete('starts_on')
    }

    if(this.viewValue != 'flexible') {
      url.searchParams.set('view', this.viewValue)
    } else {
      url.searchParams.delete('view')
    }

    Object.entries(this.filtersValue).forEach((filter) => {
      const [key, value] = filter
      const is_array = key.includes('[]')

      if(key == 'subject_roster_ids[]') {
        return
      }

      if(is_array) {
        value.map((el, _i) => url.searchParams.append(key, el))
      } else {
        url.searchParams.set(key, value)
      }
    })

    //console.log('changeBrowserUrl | url.toString()', url.toString())
    history.pushState({}, null, url.toString())
    Turbo.navigator.history.replace(url.toString())
  }

  dateSelectTargetConnected(target) {
    const context = this

    const config = {
      enableTime: false,
      dateFormat: 'd/m/Y',
      disableMobile: true,
      locale: {
        firstDayOfWeek: 1
      },
      // dateFormat: 'Y-m-d',
      // altInput: true,
      // altFormat: 'd/m/Y',
      onChange: function(_selectedDates, dateStr, _instance) {
        let [d,m,y] = dateStr.split('/')

        const dateStrFormatted = `${y}-${m}-${d}`

        context.startsOnValue = dateStrFormatted

        //let url = new URL(`${context.initialUrlValue.split('?')[0]}?${window.location.href.split("?")[1]}`)
        let url = new URL(context.initialUrlValue)

        url.searchParams.set('starts_on', context.startsOnValue)

        // context.frameTarget.src = url.toString()
        // context.changeBrowserUrl()
        //context.renderTurboStreamFromUrl(src, 'update', 'calendar')

        const src = url.toString()
        //console.log('calendar | dateSelectTargetConnected | onChange | src', src)

        //Turbo.visit(`${src}.turbo_stream`, { action: 'update', frame: 'calendar', turbo: true, acceptsStreamResponse: true })

        Turbo.visit(src, { frame: 'calendar' })
      }
    }
    flatpickr(target, config)
  }

  filtersToggle(event) {
    //console.log('filtersToggle', event.delegateTarget.classList.contains('collapsed'))
    if(event.delegateTarget.classList.contains('collapsed')) {
      Cookies.remove(calendarFiltersExpandedCookieName)
    } else {
      Cookies.set(calendarFiltersExpandedCookieName, 'true', { sameSite: 'lax' })
    }
  }

  uaShiftsToggle(event) {
    //console.log('uaShiftsToggle', event.delegateTarget.classList.contains('collapsed'))
    if(event.delegateTarget.classList.contains('collapsed')) {
      Cookies.remove(calendarUaShiftsExpandedCookieName)
    } else {
      Cookies.set(calendarUaShiftsExpandedCookieName, 'true', { sameSite: 'lax' })
    }
  }

  filtersValueChanged(value, prevValue) {
    //console.log('filtersValueChanged', value, prevValue)

    if(Object.entries(value).length == 0 && !prevValue) {
      return
    }

    // done in before stream render
    //this.changeBrowserUrl()

    if(!this.hasFiltersAppliedInfoTarget) {
      return
    }

    if(this.filtersValue && Object.keys(this.filtersValue).length > 0) {
      this.filtersAppliedInfoTarget.classList.remove('d-none')
    } else {
      this.filtersAppliedInfoTarget.classList.add('d-none')
    }
  }

  clearFilters() {
    // required because form.reset() does not reset tomselects
    const selects = this.filtersFormTarget.getElementsByClassName('tomselected')
    for (let ts of selects) {
      ts.tomselect.clear()
    }

    this.filtersFormTarget.reset()
    this.filtersFormTarget.querySelector('input#q_user_name').value = ''

    this.filtersValue = {}
  }

  headerTargetConnected(target) {
    this.renderPopovers(target)
  }

  rowTargetConnected(target) {
    //console.log('rowTargetConnected', target, this.initialLoadValue)
    this.renderPopovers(target)
  }

  // used by navigation buttons only, not by flatpickr
  changeStartsOn(event) {
    //console.log('changeStartsOn', event.params)
    this.startsOnValue = event.params.startsOn
  }

  changeView(event) {
    //console.log('changeView', event.params)
    this.viewValue = event.params.view
    this.startsOnValue = event.params.startsOn
  }

  initialLoadValueChanged() {
    //console.log('initialLoadValueChanged', this.initialLoadValue)
    if(this.initialLoadValue == false) {
      this.afterInitialLoad()
    }
  }

  viewValueChanged(value, previousValue) {
    if(this.initialLoadValue || !this.hasContainerTarget) {
      return
    }

    this.containerTarget.classList.replace(previousValue, value)

    // that months days count stuff probably not needed
    if(this.viewValue == 'month' && this.startsOnValue) {
      const starts_on = new Date(this.startsOnValue)
      const eof_month = new Date(starts_on.getFullYear(), starts_on.getMonth() + 1, 0)
      const days_count = eof_month.getDate()

      // set attribute used by css to style days in month view
      this.containerTarget.setAttribute('data-month-days-count', days_count)
    }
  }

  renderPopovers(target) {
    if(!target) {
      target = this.element
    }
    let popoverTriggerList = [].slice.call(target.querySelectorAll('a[data-bs-toggle="popover"]'))
    let popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
      return new bootstrap.Popover(popoverTriggerEl, { container: '.calendar', html: true })
    })
  }
}
